module.exports = __webpack_public_path__ + "img/equal-housing-opportunity-logo-white-png.3935ead0.png";